import dynamic from 'next/dynamic';

const DirectionsMap = dynamic(
  () => import('./directionsMap/directionsMap.components'),
  {
    ssr: false,
  },
);

export { DirectionsMap };
